import type { Action } from 'state/actions';
import { addKey, removeKey } from 'state/utils/collection';

import type { ReloadedState } from './reloadedTiles.model';
import { initialReloadedState } from './reloadedTiles.model';

export function reloadedTilesReducer(state: ReloadedState = initialReloadedState, action: Action): ReloadedState {
  switch (action.type) {
    case 'DASHBOARD_LOADING':
      return { ...state, isLoading: true } as ReloadedState;
    case 'DASHBOARD_LOADED':
      return {
        isLoading: false,
        tiles: Object.entries(action.tiles).reduce(
          (currentState, [quoteId, tileData]) => addKey(currentState, quoteId, tileData),
          state.tiles,
        ),
      };
    case 'DASHBOARD_TILE_REMOVED':
      return { ...state, tiles: removeKey(state.tiles, action.quoteId) };
    case 'DASHBOARD_OBSOLETE_QUOTES_DELETED':
      return {
        ...state,
        tiles: action.quoteIds.reduce((currentState, quoteId) => removeKey(currentState, quoteId), state.tiles),
      };
  }
  return state;
}
